import { useState } from 'react';
import CreateLinkModal from './CreateLinkModal';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateLinkPrompt = ({
  deckId,
  name,
  gdprSettings
}) => {
  const [showCreateLinkModal, setShowCreateLinkModal] = useState(false);
  const renderCreateLinkModal = () => {
    if (!deckId) {
      return null;
    }
    return showCreateLinkModal && /*#__PURE__*/_jsx(CreateLinkModal, {
      deckId: deckId,
      name: name,
      gdprSettings: gdprSettings,
      onReject: () => setShowCreateLinkModal(false)
    });
  };
  return {
    showCreateLinkModal: () => setShowCreateLinkModal(true),
    renderCreateLinkModal
  };
};
export default CreateLinkPrompt;